<script>
import { Bar } from 'vue-chartjs';
export default {
  extends: Bar,
  props:{
    chartData: {
      type: Object
    },
    yAxisUnit: {
      type: String,
      default: "%"
    }
  },
  computed: {
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            barThickness: 40
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              steps: 10,
              stepValue: 5,
              max: 100
            }
          }]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: ((tooltipItems) => {
              return " " + tooltipItems.yLabel + this.yAxisUnit
            })
          }
        }
      }
    }
  },
  methods: {
    update() {
      this.$data._chart.destroy()
      this.renderChart(this.chartData, this.options)
    }
  },
  watch: {
    chartData() {
      this.update()
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
};
</script>